import PostDeleteModal from './PostDeleteModal';

export default PostDeleteModal;
